export const TURNSTILE_ACTION = "murtada_apply";

export const turnstileEnabled = Boolean(
  import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim(),
);
